import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faFilm } from '@fortawesome/free-solid-svg-icons';

const TabsContainer = styled.div`
  margin: 30px 0 20px;
`;

const TabsHeader = styled.div`
  display: flex;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 20px;
`;

const Tab = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.$active ? 'var(--primary-light)' : 'var(--text-dim)'};
  font-size: 15px;
  font-weight: ${props => props.$active ? '600' : '500'};
  padding: 10px 20px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  
  &:hover {
    color: ${props => props.$active ? 'var(--primary-light)' : 'var(--text-light)'};
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--primary-light);
    transform: scaleX(${props => props.$active ? 1 : 0});
    transform-origin: bottom left;
    transition: transform 0.3s ease;
  }
  
  svg {
    margin-right: 8px;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    padding: 10px;
    font-size: 14px;
  }
`;

const ContentTab = styled.div`
  display: ${props => props.$visible ? 'block' : 'none'};
  
  /* Added max-width for comments section */
  ${props => props.$isComments && `
    max-width: 800px;
    margin: 0 auto;
  `}
`;

const TabCount = styled.span`
  background-color: rgba(59, 130, 246, 0.15);
  color: var(--primary-light);
  font-size: 11px;
  padding: 1px 5px;
  border-radius: 10px;
  margin-left: 6px;
  min-width: 18px;
  text-align: center;
`;

const ContentTabs = ({ activeTab, onTabChange, tabs, children }) => {
  return (
    <TabsContainer>
      <TabsHeader>
        {tabs.map(tab => (
          <Tab
            key={tab.id}
            $active={activeTab === tab.id}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.icon && <FontAwesomeIcon icon={tab.icon} />}
            {tab.label}
            {tab.count > 0 && <TabCount>{tab.count}</TabCount>}
          </Tab>
        ))}
      </TabsHeader>
      {React.Children.map(children, (child, index) => (
        <ContentTab $visible={activeTab === tabs[index].id} $isComments={tabs[index].id === 'comments'}>
          {child}
        </ContentTab>
      ))}
    </TabsContainer>
  );
};

export default ContentTabs; 